import ReactDOM from 'react-dom/client';
import App from './App';

import '@vfpt/common-fe-components/dist/index.css';
import './assets/fonts/stylesheet.css';
import './index.css';

import './modules/httpClient'; // Initialize HTTP client with interceptors
import './modules/store'; // Initialize Redux store and context
import './modules/entitlements'; // Initialize entitlements module
import './modules/contentful'; // Initialize contentful module

import { ThemeProvider } from './providers';

window.ThemeProvider = ThemeProvider;

function setFavicon() {
    const path = window.location.pathname.toLowerCase();

    let icon = '/assets/vodafone-logo.png';

    if (path.startsWith('/amigo')) {
        icon = '/assets/amigo-logo.png';
    }

    const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;

    if (favicon) {
        favicon.href = icon + '?v=' + Date.now(); // avoid cache issues
    }
}

setFavicon();

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(<App />);
